import { FolderId, ROOT_FOLDER_ID } from '@/utils/folders';

export type TargetFolder = { id: string | null; name: string } | undefined;

export const toTargetFolder = (folder?: { id?: FolderId; name?: string }): TargetFolder => {
  if (folder?.id === ROOT_FOLDER_ID) return { id: ROOT_FOLDER_ID, name: 'Assets home' };
  if (!folder?.id) return undefined;
  return { id: folder.id, name: folder.name || 'selected folder' };
};
